export const FEED = 200
export const MEAL = 100
export const CHRISTMAS = 202
export const CULTURE = 400
export const MOBILITY = 302
export const MULTIBENEFITS = 568
export const AWARDS = 608
export const FLEET = 301
export const EXPENSES = 607
export const PAYMENTS = 606
export const VT = 998
export const VELOE = 999
export const TUDO = 900
export const POD = 700
